import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ContentElement, GridCell } from '../../models/sections-model';

@Component({
  selector: 'kw-blog-article-link-renderer',
  templateUrl: './blog-article-link-renderer.component.html',
  styleUrls: ['./blog-article-link-renderer.component.scss']
})
export class BlogArticleLinkRendererComponent implements OnInit {
  @Input() gridCell:GridCell
  @Input() edit:boolean;
  contentElements:ContentElement[];

  @Output() createGridCellContent = new EventEmitter<GridCell>();
  
  constructor() { }

  ngOnInit(): void {
  }

  createContent(e){
    this.createGridCellContent.emit(e);
  }
}
